<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(
        defineProps<{
            shouldBeVisible?: boolean;
        }>(),
        {
            shouldBeVisible: undefined,
        }
    );

    const fetchTrombosprofylax = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/trombosprofylax/fetchTrombosprofylax", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/trombosprofylax/trombosprofylaxSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta trombosprofylax");
        }
    };
</script>

<template>
    <KAutocomplete
        name="trombosprofylax"
        label="Trombosprofylax"
        v-bind="$attrs"
        :options="fetchTrombosprofylax"
        :converter="defaultAutocompleteConverter"
        :shouldBeVisible="shouldBeVisible"
    />
</template>

<style lang="scss" scoped></style>
